import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlideAjaxResponse } from '../models/catalog-form';
import { CatalogFormService } from './catalog-form.service';

// Stable seam for `GFormMock.new GlideAjax(...)` when Prashant's `GFormMock.js`
// vendors in (plan §4). The mock's Ajax adapter calls into `invoke()` here so
// the rest of the SPA never needs to know that GlideAjax under the hood is a
// `POST /catalog/executeGlideAjax` — swap the transport in one place if it
// ever moves.
@Injectable({ providedIn: 'root' })
export class GlideAjaxBridgeService {
  private readonly _catalogFormService = inject(CatalogFormService);

  invoke(
    catalogItemSysId: string,
    scriptInclude: string,
    method: string,
    params: Record<string, unknown> = {},
  ): Observable<GlideAjaxResponse> {
    return this._catalogFormService.executeGlideAjax({
      catalogItemSysId,
      scriptInclude,
      method,
      params,
    });
  }
}
